module.exports = require('./lib/dynamic');



//////////////////
// WEBPACK FOOTER
// ./node_modules/dva/dynamic.js
// module id = e6LR
// module chunks = 18